import apiClient from "./apiClient";
import {
  FilterDetailsRequest,
  FilterDetailsResponse,
  ExecuteActionRequest,
} from "./Models/FilterDetailsModel";
import { AxiosResponse } from "axios";
import { SiteParametersResponse } from "./Models/SiteParametersModel";
import { PagingInfo, Condition } from "./Models/BaseModel";
import { IDmsPageResponse } from "./Models/DmsPagination";
import {
  RowFilterActionsRequest,
  RowFilterActionsResponse,
} from "./Models/FilterDetailsModel";

export const getFilterDetails = async (
  securityToken: string,
  language: string,
  filterId: number,
  objectId: number | undefined,
  pageNumber: number,
  pageSize: number | undefined,
  searchParam: string,
  searchExpression: string,
  sort: string,
  conditions: Condition[]
): Promise<IDmsPageResponse<FilterDetailsResponse>> => {
  let siteParameters: SiteParametersResponse = JSON.parse(
    localStorage.getItem("SiteParameters") ?? ""
  ) as SiteParametersResponse;

  const pageRequest: PagingInfo = {
    CurrentPage: pageNumber,
    PageSize: pageSize,
  };
  const requestData: FilterDetailsRequest = {
    SecurityToken: securityToken,
    Language: language,
    CmsFilterId: filterId,
    IdObject: objectId,
    RequestedPage: pageRequest,
    SearchInfo: {
      SearchExpression: searchExpression,
      SearchText: searchParam,
      Conditions: conditions,
    },
    Sort: sort,
    Anteprima: siteParameters.Anteprima === "1" ? true : false,
    DownloadInApertura: siteParameters.DownloadInApertura,
    ViewIcone: siteParameters.Anteprima === "1" ? true : false,
    Visualizzazione: siteParameters.Visualizzazione,
    ContPubFiltro: siteParameters.ContPubFiltro,
  };

  try {
    const response: AxiosResponse<FilterDetailsResponse> = await apiClient({
      method: "post",
      url: "/FilterDetails/CMSGetFilterResult",
      data: requestData,
    });
    const responsePage: IDmsPageResponse<FilterDetailsResponse> = {
      count: response.data.PagingInfo.RecordCount ?? 0,
      totalCount: response.data.PagingInfo.RecordCount ?? undefined,
      page: response.data.PagingInfo.CurrentPage ?? 0,
      pageSize: response.data.PagingInfo.PageSize ?? 0,
      pageCount: response.data.PagingInfo.TotalPages ?? undefined,
      data: [response.data],
      availableFieldDescriptors: [],
    };
    return responsePage;
  } catch (error) {
    console.error("CMSGetFilterResult Error:", error);
    throw error;
  }
};

export const getListActions = async (
  securityToken: string,
  language: string,
  idFilter: number,
  idObject: number
): Promise<RowFilterActionsResponse> => {
  const requestData: RowFilterActionsRequest = {
    SecurityToken: securityToken,
    Language: language,
    IdFilter: idFilter,
    IdObject: idObject,
  };

  try {
    const response: AxiosResponse<RowFilterActionsResponse> = await apiClient({
      method: "post",
      url: "/FilterDetails/GetListActions",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("getListActions Error:", error);
    throw error;
  }
};

export const executeAction = async (
  securityToken: string,
  language: string,
  idFilter: number,
  idObject: number,
  idAction: number
): Promise<RowFilterActionsResponse> => {
  const requestData: ExecuteActionRequest = {
    SecurityToken: securityToken,
    Language: language,
    IdFilter: idFilter,
    IdObject: idObject,
    IdAction: idAction,
  };

  try {
    const response: AxiosResponse<RowFilterActionsResponse> = await apiClient({
      method: "post",
      url: "/FilterDetails/ExecuteAction",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("executeAction Error:", error);
    throw error;
  }
};
